import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import { useAuth } from '../../contexts/AuthContext';
import { Package, FolderOpen, Tag, TrendingUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const AdminDashboard = () => {
  const { getAuthHeader } = useAuth();
  const [stats, setStats] = useState({
    totalProducts: 0,
    activeProducts: 0,
    totalCategories: 0,
    activeOffers: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [productsRes, categoriesRes, offersRes] = await Promise.all([
        axios.get(`${API_URL}/products?limit=2000`, { headers: getAuthHeader() }),
        axios.get(`${API_URL}/categories?limit=2000`, { headers: getAuthHeader() }),
        axios.get(`${API_URL}/offers?active_only=true`, { headers: getAuthHeader() })
      ]);

      setStats({
        totalProducts: productsRes.data.length,
        activeProducts: productsRes.data.filter(p => p.is_active).length,
        totalCategories: categoriesRes.data.length,
        activeOffers: offersRes.data.length
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const statCards = [
    { icon: Package, label: 'Total de Produtos', value: stats.totalProducts, color: '#273e82' },
    { icon: TrendingUp, label: 'Produtos Ativos', value: stats.activeProducts, color: '#10B981' },
    { icon: FolderOpen, label: 'Categorias', value: stats.totalCategories, color: '#fef000' },
    { icon: Tag, label: 'Ofertas Ativas', value: stats.activeOffers, color: '#F59E0B' },
  ];

  return (
    <AdminLayout>
      <div>
        <h1 className="text-3xl font-bold mb-8" style={{ color: '#273e82', fontFamily: 'Manrope' }}>
          Dashboard
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statCards.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm"
              data-testid={`stat-card-${index}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: `${stat.color}15` }}>
                  <stat.icon size={24} style={{ color: stat.color }} />
                </div>
              </div>
              <p className="text-3xl font-bold mb-1" style={{ color: stat.color }}>
                {stat.value}
              </p>
              <p className="text-slate-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white rounded-xl p-6 border border-slate-200">
          <h2 className="text-xl font-bold mb-4" style={{ color: '#273e82', fontFamily: 'Manrope' }}>
            Bem-vindo ao Painel Administrativo
          </h2>
          <p className="text-slate-600">
            Use o menu lateral para gerenciar produtos, categorias, ofertas e configurações da loja.
          </p>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;